module.exports = __webpack_public_path__ + "static/media/tg.e0f44835.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tg.svg
// module id = 778
// module chunks = 0